import { gsap } from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

var $ = jQuery;
$(document).ready(function ($) {
    // Register the ScrollTrigger plugin with GSAP
    gsap.registerPlugin(ScrollTrigger);

    // GSAP animation for the media banner element
    gsap.to(".header-fadein span", {
        scrollTrigger: {
            trigger: ".header-fadein span",
            start: "top 80%", 
            end: "top 50%", 
            toggleActions: "play none none reset",
        },
        y: 0, 
        opacity: 1,  
        ease: "bounce.out",
        duration: 1, 
    });

    gsap.to(".shake-image", {
        rotation: 10,
        repeat: 5,
        yoyo: true,
        ease: "power1.inOut",
        duration: 0.1, 
        delay: 1,
    });

    // GSAP animation for the content image block
    gsap.to(".no-1-mask", {
        scrollTrigger: {
            trigger: ".blk-content-image",
            start: "top bottom", 
            end: "bottom top", 
            scrub: true,      
            toggleActions: "play none none none",
        },
        height: 250, 
    });

    gsap.to(".shake-badge", {
        scrollTrigger: {
            trigger: ".shake-badge", 
            start: "top bottom",
            end: "bottom top",
            toggleActions: "play none none none",
        },
        rotation: 10,
        repeat: 10,
        yoyo: true,
        ease: "power1.inOut",
        duration: 0.2,
        delay: 1.5,
    });

    // Home Page Banner GSAP
    gsap.fromTo(
        ".bnr-home-image .mug-image-wrapper, .bnr-home .header",
        { opacity: 0, scale: 1 },
        {
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
        onComplete: () => {
            gsap.fromTo(
                ".bnr-home-image .smoke-image-wrapper",
                { opacity: 0 },
                {
                    opacity: 1,
                    duration: 1.5,
                    ease: "power2.out",
                }
            );
        }
        },
        {
            opacity: 1,
            duration: 0.5,
            ease: "power2.out",
            delay: 0.5,
            onComplete: () => {
                gsap.fromTo(
                    ".bnr-home-image .smoke-image-wrapper",
                    { opacity: 0 },
                    {
                        opacity: 1,
                        duration: 0.5,
                        ease: "power2.out",
                    }
                );
            }
        },
    );

    gsap.fromTo(
        ".bnr-home-image .mug-image-wrapper, .bnr-home .header .first-title",
        { visibility: 'hidden', opacity: 0 },
        {
            visibility: 'visible',
            opacity: 1,
            duration: 0.5,
            ease: "power2.out",
            delay: 0.5,
            onComplete: () => {
                gsap.fromTo(
                    ".bnr-home-image .mug-image-wrapper, .bnr-home .header .second-title",
                    { visibility: 'hidden', opacity: 0},
                    {
                        visibility: 'visible',
                        opacity: 1,
                        duration: 0.5,
                        ease: "power2.out",
                        delay: 0.5,
                    }
                );
            }
        }
    );

    gsap.to(".bnr-home-image .mug-image-wrapper", {
        y: 25,
        ease: "none",
        scrollTrigger: {
        trigger: ".bnr-home-image .mug-image-wrapper",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        }
    });

    let mm = gsap.matchMedia();
    mm.add("(max-width: 1023px)", () => {
        gsap.to(".bnr-home-sub-content .no-1-text-wrapper", {
            y: -40,
            ease: "none",
            scrollTrigger: {
            trigger: ".bnr-home-sub-content .no-1-text-wrapper",
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            }
        });
    });

    mm.add("(min-width: 1024px)", () => {
        gsap.to(".bnr-home-sub-content .no-1-text-wrapper", {
            y: -200,
            ease: "none",
            scrollTrigger: {
            trigger: ".bnr-home-sub-content .no-1-text-wrapper",
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            }
        });

    });

    gsap.to(".no-1-text-wrapper .badge-wrapper .badge-round-1", {
        rotation: 60, // Rotates 360 degrees
        ease: "none", 
        scrub: 1,  // Smooth animation effect
        scrollTrigger: {
            trigger: ".no-1-text-wrapper .badge-wrapper .badge-round-1",
            start: "top center",  // Starts when element reaches center of viewport
            end: "bottom top",    // Ends when element leaves the top of viewport
            scrub: 1,         // Smooth animation while scrolling
        }
    });
    // END of GSAP HOME BANNER

    // Product Carousel Running Text JS
    // const marqueeText = document.querySelector(".running-text .marquee-content");
    let speedFactor = 0.8;
 
    gsap.to(".running-text .marquee-content.move-left", {
        x: '-33.3%',
        duration: 10/speedFactor,
        ease: "linear",
        repeat: -1,
    });
    
    gsap.to(".running-text .marquee-content.move-right", {
        x: '33.3%',
        duration: 10/speedFactor,
        ease: "linear",
        repeat: -1,
    });

    // GSAP animation for the testimonial block
    gsap.to(".blk-testimonial .image_column.order-1", {
        scrollTrigger: {
            trigger: ".blk-testimonial",
            toggleActions: "play none none reset",
            start: "top 80%", 
            end: "top bottom", 
        },
        x: 0, 
        ease: "power1.out",
        duration: 1,
    });

    gsap.to(".blk-testimonial .image_column.order-2", {
        scrollTrigger: {
            trigger: ".blk-testimonial",
            toggleActions: "play none none reset", 
            start: "top 80%", 
            end: "top bottom", 
        },
        x: 0,  
        ease: "power1.out",
        duration: 1
    });

    // .no-1-mask
    gsap.to(".image_right_content_left .no-1-mask", {
        scrollTrigger: {
            trigger: ".image_right_content_left",
            start: "top bottom", 
            end: "bottom top", 
            scrub: true,      
            toggleActions: "play none none none",
        },
        height: 250, 
    });

    // .shake-badge
    gsap.to('.bnr-hero-nobg-textnobg-textnoisolate .shake-badge', {
        scrollTrigger: {
            trigger: '.bnr-hero-nobg-textnobg-textnoisolate', 
            start: "top bottom",
            end: "bottom top",
            toggleActions: "play none none none",
        },
        rotation: 10,
        repeat: 10,
        yoyo: true,
        ease: "power1.inOut",
        duration: 0.2,
        delay: 0.5,
    });

    gsap.to('.blk-content-image.image_right_content_left .shake-badge', {
        scrollTrigger: {
            trigger: '.blk-content-image.image_right_content_left', 
            start: "top bottom",
            end: "bottom top",
            toggleActions: "play none none none",
        },
        rotation: 10,
        repeat: 10,
        yoyo: true,
        ease: "power1.inOut",
        duration: 0.2,
        delay: 0.5,
    });

    // Feature Grid Block
    // gsap.fromTo(
    //     ".blk-feature-grid img", 
    //     { opacity: 0 }, 
    //     { 
    //       opacity: 1, 
    //       duration: 1, 
    //       stagger: { each: 0.3 },
    //       scrollTrigger: {
    //         trigger: ".blk-feature-grid",
    //         start: "top 50%",
    //         end: "bottom top",
    //         toggleActions: "play none none reverse"
    //       }
    //     }
    // );

    let header = document.querySelector(".no1-header-navigation");
    let headerHeight = header.clientHeight;
    // mm.add("(min-width: 1024px)", () => {
        document.querySelectorAll(".slide-up").forEach((section, index, sections) => {
            ScrollTrigger.create({
                trigger: section,
                // start: `-=${headerHeight} top`,
                start: "+=100% bottom",
                // end: "+=100%",
                pin: true,
                pinSpacing: false, // Ensures sections stack
                scrub: true, // Smooth transition between sections
                // markers: true,
            });
        });
    // })
   
})

